import { useEffect } from 'react';
import { useLandbotContext } from 'context/landbot.context';
import { useVariablesContext } from 'context/variables.context';
import _get from 'lodash.get';
import TYPES from 'constants/TYPES';
import EVENTS from 'constants/EVENTS';

export default function useInput(message) {
  const { landbot } = useLandbotContext();
  const { variables } = useVariablesContext();

  useEffect(() => {
    const submit = data => landbot.sendMessage({
      ...data,
      custom_data: variables,
    });
    landbot.events.on(EVENTS.SEND_MESSAGE, submit);
    return () => landbot.events.off(EVENTS.SEND_MESSAGE, submit);
  }, [landbot, variables]);

  return {
    inputProps: {
      type: getInputType(message),
      buttons: (message.buttons || []).map((button, index) => ({
        text: button,
        payload: _get(message, `payloads.${index}`, button),
      })),
    },
  };
}

function getInputType(message) {
  if (!message) {
    return null;
  }

  let _result = null;

  if (message.samurai === undefined) {
    return null;
  }

  switch (message.type) {
    case 'text':
    case 'image':
    case 'iframe':
      if (_get(message, 'extra.hide_textbox') === true) {
        _result = null;
      } else {
        _result = TYPES.INPUT.TEXT;
      }

      if (_get(message, 'extra.textarea.size') === 'long') {
        _result = TYPES.INPUT.TEXT_LONG;
      }

      if (_get(message, 'extra.form')) {
        _result = TYPES.INPUT.FORM;
        break;
      }

      if (_get(message, 'extra.textarea')) {
        switch (_get(message, 'extra.textarea.type')) {
          case 'number':
            _result = TYPES.INPUT.NUMBER;
            break;
          case 'email':
            _result = TYPES.INPUT.EMAIL;
            break;
          case 'date':
            _result = TYPES.INPUT.DATE;
            break;
          case 'file':
            _result = TYPES.INPUT.FILE;
            break;
          case 'url':
            _result = TYPES.INPUT.URL;
            break;
          case 'location':
            _result = TYPES.INPUT.LOCATION;
            break;
          case 'tel':
            _result = TYPES.INPUT.TEL;
            break;
          default:
            break;
        }
      }
      break;

    case 'dialog':
    case 'media_dialog':
      _result = TYPES.INPUT.BUTTONS;

      if (_get(message, 'extra.buttons')) {
        switch (_get(message, 'extra.buttons.type')) {
          case 'autocomplete':
            _result = 'autocomplete';
            break;

          case 'scale':
            _result = 'scale';
            break;

          case 'rating':
            _result = 'rating';
            break;

          case 'yes_no':
            _result = 'yes_no';
            break;

          default:
            break;
        }

        const isMulti = _get(message, 'extra.buttons.multi');
        const isSearch = _get(message, 'extra.buttons.search');
        if (isMulti && isSearch) {
          _result = TYPES.INPUT.BUTTONS_MULTI_SEARCH;
        } else if (isMulti) {
          _result = TYPES.INPUT.BUTTONS_MULTIPLE;
        } else if (isSearch) {
          _result = TYPES.INPUT.BUTTONS_SEARCH;
        }
      }
      break;

    case 'cards':
      _result = TYPES.INPUT.CARDS;
      break;

    case 'referral':
      if (_get(message, 'extra.referral')) {
        _result = TYPES.INPUT.REFERRAL;
      } else if (message.buttons && message.buttons.length > 0) {
        _result = TYPES.INPUT.BUTTONS;
      }
      break;

    case 'stripe':
    case 'stripe_intent':
      _result = TYPES.INPUT.STRIPE;
      break;
    default:
  }

  return _result;
}
